export enum Status {
  Unset,
  Loading,
  Loaded,
  Error,
}
